// extracted by mini-css-extract-plugin
module.exports = {"container":"Section_container__1wYR8","actions":"Section_actions__1Du-G","count":"Section_count__3AP5v","name":"Section_name__bvzPm"};